import React from 'react';
import { Form } from 'antd';
import { observer } from 'mobx-react-lite';
import { useForm } from 'antd/es/form/Form';
import LoanLayout from '../LoanLayout';
import { useLoan } from '../../stores/store';
import Loading from '../Loading';
import EmployerForm from '../components/EmployerForm';
import ButtonNav from '../../components/ButtonNav/ButtonNav';
import { stepFinished } from '../../nav';

type Props = {};

const CoBorrowerPreviousEmployerStep: React.FC<Props> = observer(() => {
  const loanStore = useLoan();
  const { loan } = loanStore;
  const [form] = useForm();

  if (!loan || loanStore.status === 'pending') {
    return <Loading />;
  }
  const employer = loanStore.getCoBorrowerPreviousEmployer();

  const update = (values: any) => {
    // noinspection JSIgnoredPromiseFromCall
    stepFinished();
  };

  return (
    <LoanLayout>
      <h1>Co-borrower&apos;s Previous Employment</h1>
      <Form form={form} onFinish={update} initialValues={employer}>
        <EmployerForm employer={employer} form={form} isCoBorrower />

        <ButtonNav />
      </Form>
    </LoanLayout>
  );
});

export default CoBorrowerPreviousEmployerStep;
